import { __decorate, __metadata } from "tslib";
import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsNotEmpty, IsNumber, Max, Min } from 'class-validator';
import { WebMerchantExposeGroup } from '../interface';
export class ReadWebMerchantThemeBorderRadiiDto {
}
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    Min(0, { always: true }),
    Max(5, { always: true }),
    __metadata("design:type", Number)
], ReadWebMerchantThemeBorderRadiiDto.prototype, "xs", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    Min(6, { always: true }),
    Max(9, { always: true }),
    __metadata("design:type", Number)
], ReadWebMerchantThemeBorderRadiiDto.prototype, "md", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    Min(10, { always: true }),
    Max(14, { always: true }),
    __metadata("design:type", Number)
], ReadWebMerchantThemeBorderRadiiDto.prototype, "lg", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    Min(15, { always: true }),
    Max(20, { always: true }),
    __metadata("design:type", Number)
], ReadWebMerchantThemeBorderRadiiDto.prototype, "xl", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    Min(100, { always: true }),
    Max(1000, { always: true }),
    __metadata("design:type", Number)
], ReadWebMerchantThemeBorderRadiiDto.prototype, "rounded", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNotEmpty({ always: true }),
    IsNumber(),
    Min(0, { always: true }),
    Max(0, { always: true }),
    __metadata("design:type", Number)
], ReadWebMerchantThemeBorderRadiiDto.prototype, "none", void 0);
//# sourceMappingURL=ReadWebMerchantThemeBorderRadiiDto.js.map